export default __webpack_public_path__ + "static/media/06.e8ffbcae.jpg";